export default __webpack_public_path__ + "static/Romie-Bold-8ed79ec5d6098d01ad2b3d37baf3d249.woff2";